import { createSlice } from '@reduxjs/toolkit';
import { service } from '../shared/_services/api_service';
import { errorHandler } from '../shared/_helper/responseHelper';

const initialState = {
  // individual teacher report
  hoursData: null,
  isHoursLoading: false,
  hoursError: null,
  activeFilter: 'week',
  customStart: '',
  customEnd: '',

  // consolidated (all teachers) report
  consolidatedData: null,
  isConsolidatedLoading: false,
  consolidatedFilter: 'week',
  consolidatedStart: '',
  consolidatedEnd: '',
};

export const teacherHoursSlice = createSlice({
  name: 'teacherHours',
  initialState,
  reducers: {
    setHoursLoading(state, { payload })       { state.isHoursLoading = payload; },
    setHoursData(state, { payload })           { state.hoursData = payload; state.hoursError = null; },
    setHoursError(state, { payload })          { state.hoursError = payload; state.hoursData = null; },
    setActiveFilter(state, { payload })        { state.activeFilter = payload; },
    setCustomRange(state, { payload })         { state.customStart = payload.start; state.customEnd = payload.end; },
    resetHours(state) {
      state.hoursData = null; state.hoursError = null;
      state.activeFilter = 'week'; state.customStart = ''; state.customEnd = '';
    },

    // consolidated
    setConsolidatedLoading(state, { payload }) { state.isConsolidatedLoading = payload; },
    setConsolidatedData(state, { payload })    { state.consolidatedData = payload; },
    setConsolidatedFilter(state, { payload })  { state.consolidatedFilter = payload; },
    setConsolidatedRange(state, { payload })   { state.consolidatedStart = payload.start; state.consolidatedEnd = payload.end; },
  },
});

export const {
  setHoursLoading, setHoursData, setHoursError,
  setActiveFilter, setCustomRange, resetHours,
  setConsolidatedLoading, setConsolidatedData,
  setConsolidatedFilter, setConsolidatedRange,
} = teacherHoursSlice.actions;

export default teacherHoursSlice.reducer;

/** Thunk: individual teacher hours */
export function fetchTeacherHours(teacherId, filter, startDate, endDate) {
  return async function fetchTeacherHoursThunk(dispatch) {
    dispatch(setHoursLoading(true));
    try {
      await service.getTeacherClassHours(teacherId, filter, startDate, endDate).then(
        (res) => { dispatch(setHoursLoading(false)); dispatch(setHoursData(res.data)); },
        (err) => { dispatch(setHoursLoading(false)); dispatch(setHoursError(err?.response?.data?.message || 'Failed')); errorHandler(err.response); }
      );
    } catch { dispatch(setHoursLoading(false)); }
  };
}

/** Thunk: consolidated all-teachers report */
export function fetchConsolidatedReport(filter, startDate, endDate) {
  return async function fetchConsolidatedThunk(dispatch) {
    dispatch(setConsolidatedLoading(true));
    try {
      await service.getConsolidatedReport(filter, startDate, endDate).then(
        (res) => { dispatch(setConsolidatedLoading(false)); dispatch(setConsolidatedData(res.data)); },
        (err) => { dispatch(setConsolidatedLoading(false)); errorHandler(err.response); }
      );
    } catch { dispatch(setConsolidatedLoading(false)); }
  };
}

